import React from 'react';
import PropTypes from 'prop-types';
import './sub-head.scss';

const MiniHed = ({ data, className }) => (<h3 className={className}>{data}</h3>);

MiniHed.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default MiniHed;
